var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime-corejs2/core-js/object/define-property", "@babel/runtime-corejs2/core-js/object/define-properties", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptors", "@babel/runtime-corejs2/core-js/object/get-own-property-descriptor", "@babel/runtime-corejs2/core-js/object/get-own-property-symbols", "@babel/runtime-corejs2/core-js/object/keys", "@babel/runtime-corejs2/helpers/defineProperty", "@babel/runtime-corejs2/helpers/slicedToArray", "react", "prop-types", "classnames", "../../propTypes", "../../UI/Interchange/Interchange", "../../css", "../../UI/TitlePlaceholder/TitlePlaceholder", "../../UI/Icon/Icon"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime-corejs2/core-js/object/define-property"), require("@babel/runtime-corejs2/core-js/object/define-properties"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"), require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"), require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"), require("@babel/runtime-corejs2/core-js/object/keys"), require("@babel/runtime-corejs2/helpers/defineProperty"), require("@babel/runtime-corejs2/helpers/slicedToArray"), require("react"), require("prop-types"), require("classnames"), require("../../propTypes"), require("../../UI/Interchange/Interchange"), require("../../css"), require("../../UI/TitlePlaceholder/TitlePlaceholder"), require("../../UI/Icon/Icon"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.defineProperties, global.getOwnPropertyDescriptors, global.getOwnPropertyDescriptor, global.getOwnPropertySymbols, global.keys, global.defineProperty, global.slicedToArray, global.react, global.propTypes, global.classnames, global.propTypes, global.Interchange, global.css, global.TitlePlaceholder, global.Icon);
    global.TeaserSidebar = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _defineProperties, _getOwnPropertyDescriptors, _getOwnPropertyDescriptor, _getOwnPropertySymbols, _keys, _defineProperty3, _slicedToArray2, _react, _propTypes, _classnames, _propTypes2, _Interchange, _css, _TitlePlaceholder, _Icon) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty2(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _defineProperties = _interopRequireDefault(_defineProperties);
  _getOwnPropertyDescriptors = _interopRequireDefault(_getOwnPropertyDescriptors);
  _getOwnPropertyDescriptor = _interopRequireDefault(_getOwnPropertyDescriptor);
  _getOwnPropertySymbols = _interopRequireDefault(_getOwnPropertySymbols);
  _keys = _interopRequireDefault(_keys);
  _defineProperty3 = _interopRequireDefault(_defineProperty3);
  _slicedToArray2 = _interopRequireDefault(_slicedToArray2);
  _react = _interopRequireWildcard(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _classnames = _interopRequireDefault(_classnames);
  _propTypes2 = _interopRequireDefault(_propTypes2);
  _Interchange = _interopRequireDefault(_Interchange);
  _TitlePlaceholder = _interopRequireDefault(_TitlePlaceholder);
  _Icon = _interopRequireDefault(_Icon);

  function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

  function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

  var TeaserSidebar = function TeaserSidebar(_ref) {
    var beginsAt = _ref.beginsAt,
        breakpointFormat = _ref.breakpointFormat,
        broadcastAt = _ref.broadcastAt,
        className = _ref.className,
        duration = _ref.duration,
        hover = _ref.hover,
        images = _ref.images,
        kind = _ref.kind,
        labels = _ref.labels,
        linkElement = _ref.linkElement,
        placeholder = _ref.placeholder,
        renderLink = _ref.renderLink,
        showLiveInInterchange = _ref.showLiveInInterchange,
        theme = _ref.theme,
        title = _ref.title,
        titlesElement = _ref.titlesElement,
        tracking = _ref.tracking,
        url = _ref.url,
        urlRel = _ref.urlRel,
        urlTarget = _ref.urlTarget,
        visible = _ref.visible,
        thumbnailEnabled = _ref.thumbnailEnabled;

    var _ref2 = typeof kind === 'string' || kind === null ? [kind, kind] : [kind.code, kind.label],
        _ref3 = (0, _slicedToArray2.default)(_ref2, 2),
        kindCode = _ref3[0],
        kindLabel = _ref3[1];

    var component = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(className, "__image")
    }, /*#__PURE__*/_react.default.createElement(_Interchange.default, {
      breakpointFormat: breakpointFormat,
      hover: _css.hovers[hover],
      images: images,
      thumbnailEnabled: thumbnailEnabled,
      title: title,
      visible: visible
    }, kindCode in _propTypes2.default.kindMap ? /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(className, "__kind")
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: _propTypes2.default.kindMap[kindCode],
      size: "custom",
      title: kindLabel
    })) : null)), /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(className, "__caption")
    }, !placeholder ? /*#__PURE__*/_react.default.createElement(_react.Fragment, null, titlesElement, duration > 0 && theme !== 'presse' && /*#__PURE__*/_react.default.createElement("p", {
      className: "".concat(className, "__duration ").concat(theme)
    }, "".concat(duration, " ").concat(labels.durationUnit)), beginsAt && !showLiveInInterchange && /*#__PURE__*/_react.default.createElement("p", {
      className: "".concat(className, "__date ").concat(theme)
    }, beginsAt), broadcastAt && !showLiveInInterchange && theme === 'presse' && /*#__PURE__*/_react.default.createElement("p", {
      className: "".concat(className, "__date ").concat(theme)
    }, broadcastAt)) : /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_TitlePlaceholder.default, {
      titleLevel: 3,
      width: 80
    }), /*#__PURE__*/_react.default.createElement(_TitlePlaceholder.default, {
      titleLevel: 5,
      width: 20
    }))));

    if (url) {
      var linkProps = {
        className: "".concat(className, "__link"),
        href: url,
        onClick: tracking,
        rel: urlRel,
        target: urlTarget
      };

      if (renderLink) {
        return /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)(className, {
            'is-placeholder': placeholder
          })
        }, renderLink(_objectSpread(_objectSpread({}, linkProps), {}, {
          children: component
        })));
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _classnames.default)(className, {
          'is-placeholder': placeholder
        })
      }, /*#__PURE__*/_react.default.cloneElement(linkElement, linkProps, component));
    }

    return /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _classnames.default)(className, {
        'is-placeholder': placeholder
      })
    }, component);
  };

  TeaserSidebar.propTypes = {
    beginsAt: _propTypes.default.string,
    breakpointFormat: _propTypes.default.shape(),
    broadcastAt: _propTypes.default.string,
    className: _propTypes.default.string,
    duration: _propTypes.default.number,
    hover: _propTypes.default.string,
    images: _propTypes.default.arrayOf(_propTypes.default.shape()).isRequired,
    kind: _propTypes.default.shape(),
    labels: _propTypes.default.shape({
      durationUnit: _propTypes.default.string,
      removeFavorite: ''
    }),
    linkElement: _propTypes.default.element,
    placeholder: _propTypes.default.bool,
    renderLink: _propTypes.default.func,
    showLiveInInterchange: _propTypes.default.bool,
    title: _propTypes.default.string.isRequired,
    titlesElement: _propTypes.default.node,
    tracking: _propTypes.default.func,
    url: _propTypes.default.string,
    urlRel: _propTypes.default.string,
    urlTarget: _propTypes.default.string,
    visible: _propTypes.default.bool,
    theme: _propTypes.default.string,
    thumbnailEnabled: _propTypes.default.bool
  };
  TeaserSidebar.defaultProps = {
    breakpointFormat: _propTypes2.default.breakpointFormat,
    className: 'next-teaser-sidebar',
    hover: 'basic',
    kind: null,
    labels: {
      durationUnit: 'min',
      removeFavorite: ''
    },
    linkElement: /*#__PURE__*/_react.default.createElement("a", null),
    placeholder: false,
    showLiveInInterchange: false,
    title: '',
    tracking: function tracking() {},
    visible: true,
    theme: 'theme',
    thumbnailEnabled: false
  };
  var _default = TeaserSidebar;
  _exports.default = _default;
});